const isExportedToEnsureSideEffectsAreImportedCorrectly = true;

/**
 * Merges all resets into a single className which can be applied to any
 * element.
 *
 * When applied then all elements below will have the resets applied with a
 * specificity of 0, meaning that any custom styles will always take precedence
 * over our resets
 */
const rootCls = "resets--root";

export { isExportedToEnsureSideEffectsAreImportedCorrectly, rootCls };
import "./side-effect.index.linaria.module.css";
//# sourceMappingURL=side-effect.index.js.map
